import './shipment_info_track.less';
import "./track_shipment.less";
import "./progress_bar.less";

import React from 'react';
import {routerActions} from 'react-router-redux';
import {connect} from 'react-redux';
import {Link, browserHistory} from 'react-router';
import {bindActionCreators} from 'redux';
import authActions from '../auth/auth_actions';
import ShowError from '../components/error/show_error';
import DashBoardHeader from '../header_dashboard/dashboard_header';
import moment from 'moment';
import shipmentActions from './shipment_actions';
import CONSTANTS from '../common_constants';
import dashboardActions from '../dashboard/dashboard_actions';
import Map from './map';
import LoggedinFooter from '../footer/loggedin_footer';
import cookies from '../util/cookie';
import Rating from '../components/rating/rating';
import MediaQuery from 'react-responsive';
import PhoneNumber from 'react-phone-number';
import LogoutPopUp from '../components/logoutPopUp/logout_pop_up';
import PackageInfo from './package_info';

import CarrierProgressBar from './carrier_progress_bar';
import ShipperProgressBar from './shipper_progress_bar';
import RequesterProgressBar from './requester_progress_bar';

class AgentInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      agentInfo: props.agentInfo
    }
  }

  componentWillReceiveProps = (newProps) => {
    this.setState({agentInfo: newProps.agentInfo});
  }

  navigateToChat = () => {
    const {agentInfo} = this.state;
    const {shipmentId,userId,agentType} = agentInfo;

    let chatRedirectLink;
    if(agentType === "RECEIVER" && agentInfo.receiverId){
      chatRedirectLink = "/inbox-chat/" + shipmentId + "/" + userId + "?receiverId=" + agentInfo.receiverId +"&backTo=" + "track-shipment";
    }
    else chatRedirectLink = "/inbox-chat/" + shipmentId + "/" + userId + "?backTo=" + "track-shipment";
    browserHistory.push(chatRedirectLink);
  }

  render(){
    const {agentInfo} = this.state;
    const call = "tel:"+agentInfo.phoneNo;
    const profileImgUrl = agentInfo.imageUrl || "../../public/images/user_placeholder.svg";
    return(
      <div className = "agent-info-wrap agent-info-widget">
        <div className = "agent-info" id="agentInfo">
          <MediaQuery query='(max-width: 767px)'>
            <div className="agent-type">{agentInfo.agentType}</div>
          </MediaQuery>
          <div className = "profile-info">
            <div className = "profile-img" style = {{"backgroundImage": 'url("' + profileImgUrl + '")'}}></div>
            <div className = "agent-type-info">
              <h2 title={agentInfo.name} className = "name">{agentInfo.name}</h2>
              <MediaQuery query='(min-width: 768px)'>
                <div className = "agent-type">{agentInfo.agentType}</div>
              </MediaQuery>
              <MediaQuery query='(max-width: 767px)'>
                <div className="rating"><Rating rating={agentInfo.averageRating} ratingSize={"rating-size10"}/><span className="reviewNumber">({agentInfo.totalNoOfRatings})</span></div>
              </MediaQuery>
            </div>
          </div>
          <MediaQuery query='(min-width: 768px)' >
            <div className="rating">
              <Rating rating={agentInfo.averageRating} ratingSize={"rating-size10"}/><span className="reviewNumber">({agentInfo.totalNoOfRatings})</span>
            </div>
          </MediaQuery>
        </div>
        {(agentInfo.phoneNo || agentInfo.email) && <div className = "agent-info contact-info">
          {
            agentInfo.email &&
              <div className = "contact-wrap">
                <div className = "contact-label">Email</div>
                <div className = "email-contact-wrap">
                  <div className = "contact-value">{agentInfo.email}</div>
                </div>
              </div>
          }
          {
            agentInfo.phoneNo && <div className = "contact-wrap">
            <div className = "contact-label">Phone Number</div>
              <div className = "contact-value"><a href={call}><PhoneNumber number={agentInfo.phoneNo} /></a>
                {(agentInfo.receiverId && agentInfo.agentType === "RECEIVER") && agentInfo.shipmentStatus!=9 && <span className = "icon-email email-img" onClick = {this.navigateToChat}></span>}
                {( agentInfo.agentType === "SHIPPER" || agentInfo.agentType === "CARRIER") && agentInfo.shipmentStatus!=9 && <span className = "icon-email email-img" onClick = {this.navigateToChat}></span>}
              </div>
            </div>
          }
        </div>}
      </div>
    )
  }
}

class TrackShipment extends React.Component{
  constructor(props){
    super(props);
    const shipment = props.shipment && props.shipment.shipmentDetails;
    this.state = {
      isLoading: false,
      isShipping: true,
      error: '',
      shipment
    }
    this.formatShipmentDetails = this.formatShipmentDetails.bind(this);
    this.getShipmentInfo = this.getShipmentInfo.bind(this);
    this.getAgentInfo = this.getAgentInfo.bind(this);
    this.getRecipientInfo = this.getRecipientInfo.bind(this);
    this.logout = this.logout.bind(this);
  }

  logout(){
    this.props.authActions.logout().always(() => {
          cookies.delete('_sd');
          document.location.href = '/';
     });
  }

  componentWillReceiveProps(newProps){
    this.setState({"shipment": newProps.shipment.shipmentDetails});
  }

  formatShipmentDetails(shipment){
    const deliveryLocation = shipment.deliveryCity + ", " + shipment.deliveryCountry;
    const pickupUser = shipment.isIWillMeetCarrierAtPickup ? "I will meet the carrier" : (shipment.pickupUser.name+" will meet the carrier");

    return({
      title: shipment.title,
      deliveryLocation: "Deliver to " + shipment.deliveryLocation,
      shipmentCost: shipment.shipmentCost,
      packageValue: shipment.itemValue,
      packageSize: CONSTANTS.packageSize[shipment.itemSize],
      deliverBy: shipment.deliveryDate ? moment(shipment.deliveryDate).format('ll'): '',
      pickupLocation: shipment.pickupLocation,
      pickupUser: pickupUser,
      recipient: shipment.recipientInfo.name + " will meet the carrier" || '',
      shipmentType: shipment.shipmentType
    });
  }

  componentDidMount(){
    const self = this;
    const {props} = this;
    const {shipmentActions} = this.props;
    const shipmentId = props.params.shipmentId;

    this.setState({isLoading: true});
    shipmentActions.clearShipmentDetails();
    shipmentActions.getShipmentDetails(shipmentId).then(() => {
      self.setState({
        isLoading: false,
        error: ''
      });
    }, (errorRes) => {
      if(errorRes.error === CONSTANTS.sessionInvalid){
        self.setState({isLoading: false});
        props.authActions.sessionValid(false);
        cookies.delete('_sd');
        return ;
      }
      self.setState({
        isLoading: false,
        error: errorRes.error
      });
    });
  }

  getRecipientInfo(shipment){
    let agentInfo, agentType;
    agentInfo = shipment.recipientInfo;
    agentType="RECEIVER";

    if (agentInfo) {
      return({
        imageUrl: agentInfo.profileImgUrl,
        name: agentInfo.name,
        email: agentInfo.email,
        receiverId: agentInfo.userId,
        phoneNo: agentInfo.phoneNumber,
        totalNoOfRatings: agentInfo.totalNoOfRatings,
        averageRating: agentInfo.averageRating,
        agentType: agentType,
        userId: shipment.carrierInfo.userId,
        shipmentId: shipment.shipmentId,
        agentType: agentType,
        shipmentStatus: shipment.shipmentStatus

      })
    }
    return false;
  }

  getShipmentInfo(shipment){
    return({
      shipmentId: shipment.shipmentId || "",
      imageUrl: shipment.thumbnailImage || "",
      title: shipment.title || "",
      recipient: (shipment.recipientInfo.name || "") + " | " + (shipment.deliveryLandmark || "") + (shipment.deliveryLocation || ""),
      packageSize: CONSTANTS.packageSize[shipment.itemSize],
      shipmentCost: "$" +shipment.itemValue,
      isReceiver : shipment.isReceiver,
      shipmentStatus : shipment.shipmentStatus,
      isShipper : shipment.isShipper
    });
  }

  getAgentInfo(shipment){
    let agentInfo, agentType;

    if(shipment.isShipper || shipment.isReceiver){
      agentInfo = shipment.carrierInfo;
      agentType = "CARRIER";
    }
    else if(!shipment.isShipper){
      agentInfo = shipment.shipperInfo;
      agentType="SHIPPER";
    }

    if (agentInfo) {
      return({
        imageUrl: agentInfo.profileImgUrl,
        name: agentInfo.name,
        email: agentInfo.email,
        phoneNo: agentInfo.phoneNumber || "",
        totalNoOfRatings: agentInfo.totalNoOfRatings,
        averageRating: agentInfo.averageRating,
        userId: shipment.carrierInfo.userId,
        shipmentId: shipment.shipmentId,
        agentType: agentType,
        shipmentStatus: shipment.shipmentStatus
      })
    }
    return false;
  }

  startHandoff = () => {
    const self = this;
    const {props,state} = this;

    const {shipmentId} = state.shipment;

    props.shipmentActions.startHandoff().then((shipmentId) => {
      self.setState({isLoading: false, error: ''});
    }, (errorRes) => {
      if (errorRes.error === CONSTANTS.sessionInvalid) {
        self.setState({isLoading: false});
        props.authActions.sessionValid(false);
        cookies.delete('_sd');
        return ;
      }
      self.setState({isLoading: false, error: errorRes.error})
    });
  }

  updateErrorState = (error) => {
    this.setState({"error": error});
  }

  render(){

    const {state, props} = this;
    const {userData} = props.authState;
    const shipment = state.shipment;
    let sessionValid = true ,recipientInfo;
    if("sessionValid" in props.authState.userData)
        sessionValid = props.authState.userData.sessionValid

    let user = {name: '',imageUrl: '',isVerified: ''};
    const agentInfo = this.getAgentInfo(shipment);
    if(!shipment.isShipper && !shipment.isReceiver) recipientInfo = this.getRecipientInfo(shipment);

    if(props.authState) {
      user.name = props.authState.userData.name;
      user.imageUrl = props.authState.userData.profileImageUrl;
      user.isVerified = props.authState.userData.isVerified;
    }

    let markers = {};
    let progressBarComp;

    let pickupLat = shipment.pickupLat;
    let pickupLong = shipment.pickupLong;
    let deliveryLat = shipment.deliveryLat;
    let deliveryLong = shipment.deliveryLong;

    if(shipment.shipmentType===1 && (shipment.isShipper || shipment.isReceiver)) {
      progressBarComp = <ShipperProgressBar updateErrorState = {this.updateErrorState} />
    }
    else if(shipment.shipmentType===1 && (!shipment.isShipper || !shipment.isReceiver)) {
      progressBarComp = <CarrierProgressBar updateErrorState = {this.updateErrorState} agentInfo={agentInfo}/>
    }
    else if (shipment.shipmentType===2 && !shipment.isShipper || !shipment.isReceiver && shipment.isShipper || shipment.isReceiver) {
      progressBarComp = <RequesterProgressBar updateErrorState = {this.updateErrorState} agentInfo={agentInfo}/>
    }

    return (
      <div className = "track-shipment-page">
        <DashBoardHeader user={user} logout={this.logout} />
        <LogoutPopUp isOpen={!sessionValid}></LogoutPopUp>
        <div className = "d-header-wrap">
          <div className = "wrapper">
            {shipment && <PackageInfo
                            shipmentInfo = {this.getShipmentInfo(shipment)}
                            dashboardActions = {this.props.dashboardActions}
                            authState = {this.props.authState}
                            showCancelShipment = {true}/>}
          </div>
        </div>
        {state.isLoading && <div className = "loader-wrapper"><div className = "loader"></div></div>}
        {state.error && <ShowError errorMessage={state.error}/>}
        <div className = "wrapper track-shipment-details">
          <div className = "agent-info-wrap">
            { agentInfo && <AgentInfo agentInfo={agentInfo} navigateToChat = {this.navigateToChat} />}
            { recipientInfo && shipment.shipmentType!=2 && <AgentInfo agentInfo={recipientInfo} navigateToChat = {this.navigateToChat} />}
          </div>
          { shipment && <div className = "shipment-info-track-wrap">
              <Map deliveryLat={deliveryLat}
                   deliveryLong={deliveryLong}
                   pickupLat={pickupLat}
                   pickupLong={pickupLong}/>
              <div className = "shipment-track-content">
                <div className="progress-bar-wrp">
                  {progressBarComp}
                </div>
              </div>
            </div>
          }
        </div>
        <LoggedinFooter />
      </div>
    )
  }
}

TrackShipment = connect((state) => {
  return {
    shipment: state.app.shipment,
    authState: state.app.auth
  }
}, (dispatch) => {
  return {
    shipmentActions: bindActionCreators(shipmentActions, dispatch),
    routerActions: bindActionCreators(routerActions, dispatch),
    authActions : bindActionCreators(authActions, dispatch),
    dashboardActions: bindActionCreators(dashboardActions, dispatch),
  }
})(TrackShipment);

module.exports = TrackShipment;



// WEBPACK FOOTER //
// app/shipment/track_shipment.jsx